import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { defaultAxiosInstance } from "../api/defaultInstance";
import "../css/UserReferralDetail.css";

function UserReferralDetail() {
  const location = useLocation();
  const navigate = useNavigate();

  const { email, name, referralCode, startDate, endDate, referralCodeId } = location.state || {};

  const [summary, setSummary] = useState({
    invitationCount: 0,
    conversionCount: 0,
    maintainedCount: 0,
    canceledCount: 0,
  });
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchParams, setSearchParams] = useState({
    startDate: startDate || '',
    endDate: endDate || '',
    searchUserName: '',
  });
  const [tempSearchParams, setTempSearchParams] = useState({
    startDate: startDate || '',
    endDate: endDate || '',
    searchUserName: '',
  });

  const fetchSummary = async (params) => {
    // 빈 값인 필드를 제외하는 함수
    const filterEmptyValues = (obj) => {
      const filtered = {};
      Object.keys(obj).forEach(key => {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
          filtered[key] = obj[key];
        }
      });
      return filtered;
    };

    const summaryParams = filterEmptyValues({
      referralCodeId,
      email,
      name,
      referralCode,
      startDate,
      endDate
    });

    const response = await defaultAxiosInstance.get("/referral/admin/statistics", {
      params: summaryParams,
    });
    setSummary(response.data?.data || {});
  };

  const fetchUsers = async (params) => {
    // 빈 값인 필드를 제외하는 함수
    const filterEmptyValues = (obj) => {
      const filtered = {};
      Object.keys(obj).forEach(key => {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
          filtered[key] = obj[key];
        }
      });
      return filtered;
    };

    const requestParams = filterEmptyValues({
      referralCodeId,
      email,
      name,
      referralCode,
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      searchUserName: searchParams.searchUserName,
      page,
      limit
    });

    const response = await defaultAxiosInstance.get("/referral/admin/referredUsers", {
      params: requestParams,
    });
    const result = response.data?.data;
    setUsers(Array.isArray(result.list) ? result.list : []);
    setTotal(result.total || 0);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchSummary();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, referralCodeId, email, name, referralCode, startDate, endDate]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchUsers({ referralCodeId, email, name, referralCode, startDate, endDate, page });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralCodeId, email, name, referralCode, startDate, endDate, page, limit]);


  const handleRowClick = (user) => {
    navigate("/rewards/users/detail", {
      state: {
        referralCodeId: user.referralCodeId,
        email: user.email,
        name: user.name,
        referralCode: referralCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1); // 페이지를 1로 리셋
  };

  const handleSearchParamChange = (e) => {
    const { name, value } = e.target;
    setTempSearchParams(prev => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    setSearchParams(tempSearchParams); // 임시 검색 파라미터를 실제 검색 파라미터로 복사
    setPage(1); // 검색 시 페이지를 1로 리셋
    // API 호출을 위해 fetchSummary와 fetchUsers 호출
    fetchSummary();
    fetchUsers({ 
      referralCodeId, 
      email, 
      name, 
      referralCode, 
      startDate: tempSearchParams.startDate, 
      endDate: tempSearchParams.endDate, 
      searchUserName: tempSearchParams.searchUserName,
      page: 1,
      limit 
    });
  };

  const handleReset = () => {
    const initialTempParams = {
      startDate: startDate || '',
      endDate: endDate || '',
      searchUserName: '',
    };
    setTempSearchParams(initialTempParams);
    setSearchParams(initialTempParams);
    setPage(1);
    fetchSummary();
    fetchUsers({ 
      referralCodeId, 
      email, 
      name, 
      referralCode, 
      startDate: initialTempParams.startDate, 
      endDate: initialTempParams.endDate, 
      searchUserName: '',
      page: 1,
      limit 
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(page * limit, total);

  return (
    <Layout>
      <div className="user-reward-list-container">
        {/* 1. 통계 섹션 */}
        <div className="summary">
          <div className="summary-box">초대 수<br /><strong>{summary.invitationCount}</strong></div>
          <div className="summary-box">전환 수<br /><strong>{summary.conversionCount}</strong></div>
          <div className="summary-box">3개월 차 회원 수<br /><strong>{summary.maintainedCount}</strong></div>
          <div className="summary-box">중도 해지 회원 수<br /><strong>{summary.canceledCount}</strong></div>
        </div>

        {/* 2. 필터 섹션 */}
        <div className="filter-bar">
          <div className="filter-group">
            <label>아이디</label>
            <input value={email} placeholder="아이디" disabled />
          </div>
          <div className="filter-group">
            <label>이름</label>
            <input value={name} placeholder="이름" disabled />
          </div>
          <div className="filter-group">
            <label>코드</label>
            <input value={referralCode} placeholder="코드" disabled />
          </div>
          <div className="filter-group">
            <label>페이지당 항목 수</label>
            <select value={limit} onChange={handleLimitChange}>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>
          </div>
          <div className="filter-group">
            <label>초대코드 입력일 시작</label>
            <input name="startDate" type="date" value={tempSearchParams.startDate} onChange={handleSearchParamChange} onKeyDown={handleKeyPress} />
          </div>
          <div className="filter-group">
            <label>초대코드 입력일 종료</label>
            <input name="endDate" type="date" value={tempSearchParams.endDate} onChange={handleSearchParamChange} onKeyDown={handleKeyPress} />
          </div>
          <div className="filter-group">
            <label>회원 이름</label>
            <input name="searchUserName" placeholder="회원 이름 입력" value={tempSearchParams.searchUserName} onChange={handleSearchParamChange} onKeyDown={handleKeyPress} />
          </div>
          <div className="filter-group">
            <button onClick={handleSearch}>필터 적용</button>
            <button onClick={handleReset} className="reset-btn">초기화</button>
          </div>
        </div>

        {/* 3. 테이블 헤더 섹션 */}
        <div className="table-header">
          <h3 className="section-title">회원 리스트</h3>
        </div>

        {/* 4. 테이블 섹션 */}
        <div className="user-table">
          <table>
            <thead>
              <tr>
                <th>회원 ID</th>
                <th>이름</th>
                <th>초대코드 입력일</th>
                <th>멤버십 전환일</th>
                <th>멤버십 해지일</th>
                <th>결제 회차</th>
                <th>초대 수</th>
                <th>전환 수</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={index} onClick={() => handleRowClick(user)} style={{ cursor: "pointer" }}>
                  <td>{user.email}</td>
                  <td>{user.name}</td>
                  <td>{user.regDate}</td>
                  <td>{user.conversionDate || '-'}</td>
                  <td>{user.cancelDate || '-'}</td>
                  <td>{user.paymentCount}</td>
                  <td>{user.invitationCount}</td>
                  <td>{user.conversionCount}</td>
                  <td>
                    <button className={`status-button ${user.status}`}>{user.status}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* 5. 페이징 섹션 */}
        <div className="pagination-info">
          <div>총 {total.toLocaleString()}개 항목 중 {startIndex.toLocaleString()} - {endIndex.toLocaleString()}</div>
          <div className="pagination">
            <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>이전</button>
            {Array.from({ length: Math.ceil(total / limit) }, (_, i) => (
              <button
                key={i + 1}
                className={page === i + 1 ? "active" : ""}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button onClick={() => handlePageChange(page + 1)} disabled={page * limit >= total}>다음</button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default UserReferralDetail;